import { cn } from '@listening/utils/react-helpers';
import { clamp, stringToNumberBlurHash } from '@listening/utils/ts-utils';
import blur1Png from '@listening/assets/imgs/blur-audio-thumbnail/blur1.png';
import blur2Png from '@listening/assets/imgs/blur-audio-thumbnail/blur2.png';
import blur3Png from '@listening/assets/imgs/blur-audio-thumbnail/blur3.png';
import blur4Png from '@listening/assets/imgs/blur-audio-thumbnail/blur4.png';
import blur5Png from '@listening/assets/imgs/blur-audio-thumbnail/blur5.png';

export function BlurThumbnail({
  preset,
  className,
}: {
  preset: number;
  className?: string;
}) {
  const imgIdx = clamp(Math.abs(preset % 5), 0, 5);
  const imgSrc = [blur1Png, blur2Png, blur3Png, blur4Png, blur5Png][imgIdx];
  return (
    <img
      alt='Audio Thumbnail'
      className={cn('size-6 rounded-sm', className)}
      src={imgSrc}
    />
  );
}

export function getBigBlurImageSrc(title: string) {
  const preset = stringToNumberBlurHash(title);
  const gallery = Object.values(
    import.meta.glob(
      '../../../../../../packages/core/assets/imgs/blur-audio-big/*.{png,PNG}',
      {
        eager: true,
        query: '?url',
        import: 'default',
      },
    ),
  );
  const imgIdx = clamp(Math.abs(preset % gallery.length), 0, gallery.length);
  const imgSrc = gallery[imgIdx];
  if (!imgSrc) throw new Error('No image found');
  return imgSrc;
}
